import { compareVersions } from "compare-versions";
import React from "react";

import { Option, Stack, SubmissionFormButtons } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { SoftwarePackageVersionFormDropDown } from "../common/SoftwarePackageVersionFormDropDown";

interface SoftwarePackageDefaultFormFieldProps {
  softwarePackageVersions: SoftwarePackageVersion[];
}

export const SoftwarePackageDefaultFormFields: React.FC<SoftwarePackageDefaultFormFieldProps> = ({
  softwarePackageVersions
}) => {
  const versionOptions = softwarePackageVersions
    .sort((a, b) => compareVersions(b.version, a.version))
    .map(version => ({
      key: version?.id,
      text: version?.version,
      data: version
    })) as Option<SoftwarePackageVersion>[];

  const { data: hasDeployPermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementDeploy
  );

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }}>
      <SoftwarePackageVersionFormDropDown
        name="softwarePackageVersionId"
        disabled={!hasDeployPermission}
        title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
        styles={{ root: { width: 200 } }}
        options={versionOptions}
      />
      <SubmissionFormButtons
        hideCancelButton
        submitButtonProps={{
          text: "Set Default Version"
        }}
      />
    </Stack>
  );
};
